<template>

<!--
  <div v-if="!loader" class="status">
    <div>
      <span v-if="ok" class="info">
        <i class="fa fa-check"></i>{{ texts.ok }}
      </span>
      <span v-if="error" class="info error">
        <i class="fa fa-exclamation-triangle"></i>
        <span v-html="texts.error"></span>
      </span>
    </div>
  </div>
  <div v-else id="content-loader"></div>
 -->

<div class="status">
  <div v-if="loader" id="content-loader"></div>
  <div v-else class='right'>
      <span v-if="ok" class="info">
        <i class="fa fa-check"></i>{{ texts.ok }}
      </span>
      <span v-if="error" class="info error">
        <i class="fa fa-exclamation-triangle"></i>
        <span v-html="texts.error"></span>
      </span>
  </div>
</div>

</template>

<script>
import i18n from '@/i18n'

export default {
  name: 'RequestInfo',
  //props: ['ok','error', 'loader', 'okMsg', 'errorMsg']
  props: {
    ok: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    loader: { type: Boolean, default: false },
    okMsg: { type: String },
    errorMsg: { type: String },
    additionalErrorMsg: { type: String, default: '' },
    type: { type: String },
  },
  computed: {
    texts() {
      const type = this.type ? this.type : 'request'
      const hasAdditionalErrorMsg = !!this.additionalErrorMsg
      const errorMessage = `alert.${type}.error`
      let errorMsgToShow = ''

      if (type === 'custom') {
        errorMsgToShow = this.errorMsg
      } else {
        if (hasAdditionalErrorMsg) {
          errorMsgToShow = `${i18n.t(errorMessage)}<br>${
            this.additionalErrorMsg
          }`
        } else {
          errorMsgToShow = i18n.t(errorMessage)
        }
      }

      const txts = {
        ok: type === 'custom' ? this.okMsg : i18n.t(`alert.${type}.ok`),
        error: errorMsgToShow,
      }

      return txts
    },
  },
}
</script>

<style scoped lang="scss">
.status {
  height: 35px;
  margin-top: 5px;
 
  border-top: 1px solid #ccc;
/*
   padding-top: 1px;
  text-align: right;
  clear: both;
  */
  display: flex;
  align-items: center;

   clear: both;

  .info {
    font-size: 13px;
  }

  .right {
    margin-left: aut;
  }
}

#content-loader {
  /*margin-top: 12px;*/
}
</style>
